export default __webpack_public_path__ + "static/media/Mediterranee.cb064cc2.jpg";